module.exports = __webpack_public_path__ + "img/tile-inf1.4d355dcb.jpg";